import React from 'react';

import './PageFooter.scss';

const PageFooter = () => (
  <div className="PageFooter d-flex justify-content-between">
    <div className="PageFooter-copy">All Rights Reserved to Praktio LLC</div>
    <div className="PageFooter-links d-flex">
      <a target="_blank" rel="noreferrer" href="https://praktio.com/pages/terms-of-service">
        Terms of Service
      </a>
      <a target="_blank" rel="noreferrer" href="https://praktio.com/pages/privacy-policy">
        Privacy Policy
      </a>
    </div>
  </div>
);

export default PageFooter;
